import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

/**
 * Componentes estilizados para divisores
 */
const Divider = styled.div`
    position: relative;
    height: 1px;
`;

const DivTransparent = styled(Divider)`
    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 5%;
        right: 5%;
        width: 90%;
        height: 1px;
        background-image: linear-gradient(to right, transparent, rgb(48,49,51), transparent);
    }
`;

const DivArrowDown = styled(DivTransparent)`
    &:after {
        content: '';
        position: absolute;
        z-index: 1;
        top: -6.5px;
        left: calc(25% - 7px);
        width: 14px;
        height: 14px;
        transform: rotate(45deg);
        background-color: white;
        border-bottom: 1px solid rgb(48,49,51);
        border-right: 1px solid rgb(48,49,51);
    }
`;

/**
 * Layout comum para as páginas de controle de processos.
 * @param {React.Node} children - Componentes filhos a serem renderizados dentro do layout.
 * @param {boolean} isAdmin - Indica se o usuário é administrador para exibir opções adicionais.
 */
function CiLayout({ children, isAdmin }) {
    return (
        <section className="content">
            <div className="container-fluid" style={{ marginTop: 18 }}>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            {/* Cabeçalho */}
                            <div className="card-header bg-info">
                                <div className="inner text-center">
                                    <img src="/dist/img/martelo.png" alt="Logo" />
                                </div>
                                <h3 className="text-center">Controle de CI</h3>
                            </div>
                            {/* Corpo */}
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-6" style={{ marginBottom: 10 }}>
                                        <Link to="/ci/controle">
                                            <div className="text-center">
                                                <span style={{ color: '#17a2b8' }}>Consultar Processos</span>
                                            </div>
                                        </Link>
                                    </div>
                                    {isAdmin && (
                                        <div className="col-lg-6">
                                            <Link to="/ci/novo/processo">
                                                <div className="text-center">
                                                    <span style={{ color: '#212529' }}>Gerar Novo Processo</span>
                                                </div>
                                            </Link>
                                        </div>
                                    )}
                                </div>
                                <DivArrowDown />
                                {children}
                            </div>
                            {/* Fim do corpo */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CiLayout;
